import React from 'react'
import { QRCodeSVG } from 'qrcode.react'
import { createSpaydString, PaymentQrData } from './paymentQr'

const PaymentQrCode = (props: PaymentQrData) => {
  try {
    const paymentData = createSpaydString(props)

    return (
      <QRCodeSVG
        className="payment-qr-code"
        value={paymentData}
        size={132}
        level="M"
        marginSize={4}
        title="QR platba"
      />
    )
  } catch (error) {
    console.error('QR platbu se nepodařilo vytvořit', error)
    return null
  }
}

export default PaymentQrCode
